/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendMessageBatch.defs.js'
export { main as default } from './sendMessageBatch.defs.js'
